import Box from '@gogame/ui/Box';
import { Select } from '@gogame/ui/Select';
import TextField from '@gogame/ui/TextField';

export const CohortMetric = ({ value = {}, metrics = [], onChange }) => {
  return (
    <Box display={'flex'} flexWrap={'nowrap'}>
      <Box mr={1}>
        <Select
          value={value.name}
          options={metrics}
          onChange={(e, name) => onChange(e, { ...value, name })}
          dropdownWidth={220}
          label={'Cohort Metric'}
        />
      </Box>
      <TextField
        value={value.dateRange}
        label={'Days'}
        type={'number'}
        width={'64px'}
        placeholder={'0'}
        onChange={(e) => onChange(e, { ...value, dateRange: e.target.value })}
      />
    </Box>
  );
};
